import MappingsList from './MappingsList';

export default {
  list: MappingsList,
};
